import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary capturou erro:', error, errorInfo);
  }

  handleReload = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            padding: '40px 20px',
            textAlign: 'center',
            fontFamily: 'Lato, sans-serif',
            color: '#ece7f6',
            backgroundColor: '#443c56',
          }}
        >
          <h2 style={{ color: '#42a89c', marginBottom: '16px' }}>
            Algo deu errado
          </h2>
          <p style={{ marginBottom: '24px', maxWidth: '500px', lineHeight: 1.6 }}>
            Ocorreu um erro inesperado. Tente recarregar a página.
            Se o problema persistir, entre em contato com o suporte.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              backgroundColor: '#42a89c',
              color: '#fff',
              border: 'none',
              padding: '12px 28px',
              borderRadius: '6px',
              fontSize: '16px',
              cursor: 'pointer',
            }}
          >
            Voltar ao início
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
